import clsx from 'clsx'
import {FC} from 'react'
import {formatRelative, toPersianDigits} from '../../apps/accounting-sync/core/format'
import {NotificationItem} from '../core/models'
import {
  channelLabel,
  deliveryStatusLabel,
  deliveryStatusTone,
  severityIcon,
  severityLabel,
  severityTone,
  skipReasonLabel,
} from '../core/ui'

/** One inbox row; `compact` is the header-menu variant without the delivery trail. */
export const NotificationItemView: FC<{
  item: NotificationItem
  compact?: boolean
  onOpen: (item: NotificationItem) => void
  onMarkRead?: (item: NotificationItem) => void
}> = ({item, compact, onOpen, onMarkRead}) => {
  const tone = severityTone(item.severity)
  return (
    <li
      className={clsx('notify-item', !item.isRead && 'is-unread')}
      data-testid='notification-item'
      onClick={compact ? () => onOpen(item) : undefined}
    >
      <div
        className={clsx('notify-item__icon', tone !== 'info' && `is-${tone}`)}
        aria-hidden='true'
      >
        <i className={`las ${severityIcon(item.severity)}`} />
      </div>
      <div className='notify-item__main'>
        <h3>{item.title}</h3>
        {item.body && <p>{item.body}</p>}
        <div className='notify-item__meta'>
          <span>{formatRelative(item.createdAtUtc)}</span>
          {item.companyName && (
            <span>
              کسب‌وکار: <b>{item.companyName}</b>
            </span>
          )}
          {!compact && <span>{item.groupLabel}</span>}
          {!compact && item.occurrenceCount > 1 && (
            <span>
              {toPersianDigits(item.occurrenceCount)} بار تکرار
              {item.lastOccurredAtUtc
                ? `، آخرین بار ${formatRelative(item.lastOccurredAtUtc)}`
                : ''}
            </span>
          )}
          {item.resolvedAtUtc && <span className='notify-badge is-ok'>برطرف شده</span>}
        </div>
        {!compact && item.deliveries && item.deliveries.length > 0 && (
          <div className='notify-deliveries' aria-label='وضعیت ارسال'>
            {item.deliveries.map((delivery, index) => (
              <span
                key={`${delivery.channel}-${index}`}
                className={clsx('notify-badge', `is-${deliveryStatusTone(delivery.status)}`)}
                title={
                  delivery.status === 'sent'
                    ? delivery.reference
                      ? `شماره پیگیری: ${delivery.reference}`
                      : ''
                    : skipReasonLabel(delivery.error)
                }
              >
                {channelLabel(delivery.channel)}: {deliveryStatusLabel(delivery.status)}
                {delivery.channel === 'ticket' && delivery.reference
                  ? ` (${delivery.reference})`
                  : ''}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className='notify-item__aside'>
        <span className={clsx('notify-badge', `is-${tone}`)}>{severityLabel(item.severity)}</span>
        {!compact && (
          <>
            {item.linkPath && (
              <button
                type='button'
                className='btn btn-sm btn-light-primary'
                onClick={() => onOpen(item)}
              >
                مشاهده
              </button>
            )}
            {!item.isRead && onMarkRead && (
              <button
                type='button'
                className='btn btn-sm btn-light'
                onClick={() => onMarkRead(item)}
              >
                خوانده شد
              </button>
            )}
          </>
        )}
      </div>
    </li>
  )
}
